import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from '../redux/actions';
import {
  Accordion,
  AccordionItem,
  AccordionItemHeading,
  AccordionItemButton,
  AccordionItemPanel,
  AccordionItemState,
} from 'react-accessible-accordion';
import PageDetail from '../page/PageDetail';
import { Mixpanel } from '../../../common/utils/mixpanelUtil';
import { findBySearchString } from '../../../common/utils/jsonUtils';
import CustomLoader from '../../common/CustomLoader';

export class PageTab extends Component {
  static propTypes = {
    editor: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
    projectId: PropTypes.string.isRequired,
  };

  state = { searchQuery: '', pagesBySearch: [], showLoader: false, expandedSections: ['GENERAL'] };

  componentDidMount() {
    const { projectId, actions, version } = this.props;
    if (projectId) {
      actions.loadPages({ projectId, version });
      actions.loadPageSnapshots({ projectId, version });
      actions.loadLayouts({ projectId });
    }
  }

  handleRefresh() {
    const { projectId, actions, version } = this.props;
    if (projectId) {
      this.setState({ showLoader: true });
      actions.loadPages({ projectId, version }).then(() => this.setState({ showLoader: false }));
    }
  }

  filterPagesBySearch = (event) => {
    const { value } = event.target;
    const { editor } = this.props;
    const { pages = [] } = editor;
    const filteredPages = value ? findBySearchString('name', value, pages) : pages;
    const expandedSections = [];
    if (filteredPages.some((page) => page.isPluginPage)) expandedSections.push('SYSTEM');
    if (filteredPages.some((page) => !page.isPluginPage)) expandedSections.push('GENERAL');

    this.setState({ searchQuery: value, expandedSections });
  };

  listOfPagesToShow = (pages) => {
    const { actions, projectId, currentPageId, version } = this.props;
    return pages
      .sort((a, b) => a.pageIndex - b.pageIndex)
      .map((page) => (
        <PageDetail
          key={page.uuid}
          page={page}
          version={version}
          projectId={projectId}
          togglePageModal={actions.togglePageModal}
          currentPageId={currentPageId}
          toggleCreatePage={actions.toggleCreatePage}
        />
      ));
  };

  showPages = (pages) => {
    const { searchQuery } = this.state;
    const filteredPages = searchQuery ? findBySearchString('name', searchQuery, pages) : pages;
    return filteredPages.length > 0 ? (
      this.listOfPagesToShow(filteredPages)
    ) : (
      <p style={{ fontSize: '14px', margin: '0 0 10px' }}>No matching your search.</p>
    );
  };

  renderAccordianContent = (pages) => {
    return (
      <>
        <div className="gjs-pn-panel gjs-pn-devices-c gjs-one-bg gjs-two-color width100 position-relative width100 border-bottom-theme">
          <div className="gjs-devices-c"></div>
          {this.showPages(pages)}
        </div>
      </>
    );
  };
  renderAccordion = (pages) => {
    const accordionSections = [
      {
        Id: 'SYSTEM',
        title: 'System',
        pages: pages.filter((page) => page.isPluginPage),
      },
      {
        Id: 'GENERAL',
        title: 'General',
        pages: pages.filter((page) => !page.isPluginPage),
      },
    ];
    return accordionSections.map(({ Id, title, pages }) => (
      <AccordionItem key={Id} uuid={Id}>
        <AccordionItemState>
          {({ expanded }) => (
            <>
              <AccordionItemHeading className="gjs-block-category">
                <AccordionItemButton className="gjs-title">
                  <span
                    className={
                      expanded
                        ? 'gjs-caret-icon fa fa-caret-down'
                        : 'gjs-caret-icon fa fa-caret-right'
                    }
                  ></span>
                  &nbsp;
                  {title}
                </AccordionItemButton>
              </AccordionItemHeading>
              <AccordionItemPanel>
                {pages.length === 0 ? (
                  <div>No pages available</div>
                ) : (
                  this.renderAccordianContent(pages)
                )}
              </AccordionItemPanel>
            </>
          )}
        </AccordionItemState>
      </AccordionItem>
    ));
  };

  render() {
    const { showLoader, searchQuery, expandedSections } = this.state;
    const { editor, actions, isReadOnly } = this.props;
    const { pages = [] } = editor;
    const totalPageCount = pages.length;
    return (
      <>
        <div className="gjs-pn-panel gjs-pn-devices-c gjs-one-bg gjs-two-color position-relative width100 border-bottom-theme">
          <div className="gjs-pn-buttons">
            <span title="Pages" className="padding-left-20">
              Pages&nbsp;
              <span
                style={{ fontSize: '12px', cursor: 'default' }}
                data-tip="Total"
                title={'Total: ' + totalPageCount}
              >
                <i className="webconnect webconnect-info-circle"></i>
              </span>
            </span>
            <span
              title="Reload Pages"
              className="gjs-pn-btn"
              style={{ display: 'flex', flexGrow: '1', justifyContent: 'end' }}
            >
              &nbsp;
              <a
                className="btn btn-theme-cancel btn-xs"
                data-tip="Reload Pages"
                data-place="bottom"
                data-effect="solid"
                onClick={() => this.handleRefresh()}
              >
                <i className="wb webconnect-refresh"></i>
              </a>
            </span>
            <span title={isReadOnly ? 'Read-only mode' : 'Pages'}>
              <a
                className="btn btn-theme-submit btn-xs"
                data-tip={isReadOnly ? 'Read-only mode' : 'Create New Page'}
                data-place="bottom"
                data-effect="solid"
                onClick={() => {
                  if (isReadOnly) return;
                  actions.toggleCreatePage({});
                  actions.togglePageModal();
                  Mixpanel.track('Clicked on- Add Page button on Builder');
                }}
                style={{
                  pointerEvents: isReadOnly ? 'none' : 'auto',
                  opacity: isReadOnly ? 0.5 : 1,
                  cursor: isReadOnly ? 'not-allowed' : 'pointer',
                }}
              >
                <i className="wb webconnect-plus"></i>&nbsp;Add Page
              </a>
            </span>
          </div>
        </div>
        <div id="pages" className="column blocks is-abs--t-l gjs-one-bg blocks-open">
          <div className="gjs-blocks-cs gjs-one-bg gjs-two-color">
            <div className="gjs-block-categories">
              <div className="gjs-pn-panel height35 width100 position-relative">
                <div className="form-outline" style={{ padding: '10px' }}>
                  <input
                    type="search"
                    className="form-control form-control-sm"
                    placeholder="&#xf55c; Eg: Home"
                    style={{ fontFamily: 'Arial, Webconnect' }}
                    value={searchQuery}
                    onChange={this.filterPagesBySearch}
                  />
                </div>
                {showLoader ? (
                  <CustomLoader loading={showLoader} />
                ) : (
                  <Accordion
                    key={expandedSections.join(',')}
                    allowZeroExpanded
                    preExpanded={expandedSections}
                  >
                    {this.renderAccordion(pages)}
                  </Accordion>
                )}
                <hr />
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }
}

function mapStateToProps(state) {
  return {
    editor: state.editor,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(PageTab);
